/* MundoFit PDP zoom
   Desktop (puntero fino + hover): magnifica siguiendo el cursor.
   Mobile/tactil: tap para hacer zoom en el punto, arrastrar el dedo para
   desplazar (pan), tap de nuevo para salir.
   No toca el bundle de la galeria; el <img> persiste aunque cambie src. */
(function () {
  "use strict";

  var SCALE = 2.2;
  var hasHover =
    window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function setOrigin(box, clientX, clientY) {
    var r = box.getBoundingClientRect();
    var x = ((clientX - r.left) / r.width) * 100;
    var y = ((clientY - r.top) / r.height) * 100;
    box.style.setProperty("--mf-zoom-x", Math.max(0, Math.min(100, x)) + "%");
    box.style.setProperty("--mf-zoom-y", Math.max(0, Math.min(100, y)) + "%");
  }

  function enter(box) {
    box.style.setProperty("--mf-zoom-scale", String(SCALE));
    box.classList.add("is-zooming");
  }

  function exit(box) {
    box.classList.remove("is-zooming");
  }

  function bindHover(box) {
    box.addEventListener("mouseenter", function () {
      enter(box);
    });
    box.addEventListener("mousemove", function (ev) {
      setOrigin(box, ev.clientX, ev.clientY);
    });
    box.addEventListener("mouseleave", function () {
      exit(box);
    });
  }

  function clamp(v) {
    return Math.max(0, Math.min(100, v));
  }

  function setVars(box, x, y) {
    box.style.setProperty("--mf-zoom-x", x + "%");
    box.style.setProperty("--mf-zoom-y", y + "%");
  }

  function makeHint(box, text) {
    var hint = document.createElement("div");
    hint.className = "mf-ph-zoom-hint";
    hint.setAttribute("aria-hidden", "true");
    hint.textContent = text;
    box.appendChild(hint);
    return hint;
  }

  function bindTouch(box) {
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var lastY = 0;
    var curX = 50;
    var curY = 50;
    var moved = false;
    var hint = makeHint(box, "Arrastra para explorar");
    var tapHint = makeHint(box, "Toca para ampliar");
    var hintTimer = null;
    var tapTimer = null;

    function showHint() {
      hint.classList.add("is-visible");
      clearTimeout(hintTimer);
      hintTimer = setTimeout(hideHint, 1800);
    }
    function hideHint() {
      hint.classList.remove("is-visible");
      clearTimeout(hintTimer);
    }
    function hideTapHint() {
      tapHint.classList.remove("is-visible");
      clearTimeout(tapTimer);
    }
    // pista inicial breve: invita al primer tap
    tapHint.classList.add("is-visible");
    tapTimer = setTimeout(hideTapHint, 2200);

    box.addEventListener(
      "touchstart",
      function (ev) {
        if (!ev.touches || !ev.touches.length) return;
        var t = ev.touches[0];
        startX = lastX = t.clientX;
        startY = lastY = t.clientY;
        moved = false;
        hideTapHint();
      },
      { passive: true }
    );

    box.addEventListener(
      "touchmove",
      function (ev) {
        if (!ev.touches || !ev.touches.length) return;
        var t = ev.touches[0];
        if (Math.abs(t.clientX - startX) > 6 || Math.abs(t.clientY - startY) > 6) {
          moved = true;
        }
        if (!box.classList.contains("is-zooming")) return;
        ev.preventDefault(); // evita scroll mientras se hace pan
        hideHint();
        var r = box.getBoundingClientRect();
        // delta invertido: arrastrar la imagen como si se agarrara
        var dx = ((t.clientX - lastX) / r.width) * 100;
        var dy = ((t.clientY - lastY) / r.height) * 100;
        curX = clamp(curX - dx);
        curY = clamp(curY - dy);
        setVars(box, curX, curY);
        lastX = t.clientX;
        lastY = t.clientY;
      },
      { passive: false }
    );

    box.addEventListener("touchend", function (ev) {
      if (moved) return; // arrastre = pan, no toggle
      if (box.classList.contains("is-zooming")) {
        exit(box);
        hideHint();
      } else {
        var touch =
          (ev.changedTouches && ev.changedTouches[0]) ||
          { clientX: startX, clientY: startY };
        var r = box.getBoundingClientRect();
        curX = clamp(((touch.clientX - r.left) / r.width) * 100);
        curY = clamp(((touch.clientY - r.top) / r.height) * 100);
        setVars(box, curX, curY);
        enter(box);
        showHint();
      }
    });
  }

  function bind(box) {
    if (!box || box.__mfZoomBound) return;
    if (!box.querySelector("[data-main-image]")) return;
    box.__mfZoomBound = true;
    box.classList.add("mf-ph-zoomable");
    if (hasHover) {
      bindHover(box);
    } else {
      box.classList.add("mf-ph-zoomable--touch");
      bindTouch(box);
    }
  }

  function init() {
    document
      .querySelectorAll("[data-mf-product-hero] .mf-ph-media__main")
      .forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
